<template>
    <div class="mainBox">
        <div class="mainCon">
            <stu-main-title></stu-main-title>
            <div class="content">
                <template v-if="isSuccess"> 
                    <img src="@/assets/img/pass.png" alt="">
                    <p class="f24 fb col_green mt10">您的报名费用已支付</p>
                    <p class="col_grayQ mt10">
                        <span>{{`${count}s`}}</span>
                        <span>后自动跳转至缴费结果页面，或</span>
                        <span class="col_blue cp" @click="goPay">直接跳转</span>
                    </p>
                </template>
                <template v-else>
                    <img src="@/assets/img/unpass.png" alt="">
                    <p class="f24 fb col_red mt10">报名费支付失败</p>
                    <p class="col_grayQ mt10">
                        <span>{{`${count}s`}}</span>
                        <span>后自动跳转至缴费页面，或</span>
                        <span class="col_blue cp" @click="goPay">直接跳转</span>
                    </p>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'payTransfer',
    data () {
        return {
            isSuccess: false,
            count: 6
        }
    },
    created () {
        this.tenant = window.localStorage.getItem('tenant')
        this.decompile()
    },
    mounted () {
        this.timer = setInterval(() => {
            this.count--
            if (this.count < 1) {
                this.goPay()
            }
        }, 1000)
    },
    beforeDestroy () {
        clearInterval(this.timer)
    },
    methods: {
        goPay () {
            this.$router.push({
                name: 'payFee'
            })
        },
        decompile () {
            
            let { query } = this.$route
            
            console.log(this.$route)

            for (let key of Object.keys(query)) {
                query[key] = this.dealStr(query[key])
            }



            this.isSuccess = JSON.parse(query.c.replace(`oue${this.tenant}`, ""))
            
        },
        dealStr (str) {
            return window.atob(decodeURI(str))
        }
    }
}
</script>

<style lang="less" scoped>
.mainBox {
    width: 100%;
    min-width: 700pt;
    background-color: #fff;
    border-radius: 8px;
}
.mainCon {
    box-sizing: border-box;
    padding: 20px;
    padding-top: 16px;
    height: 620px;
    width: 100%;
    background: rgba(255, 255, 255, 0.93);
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.5);
    .content {
        padding-top: 120px;
        text-align: center;
    }
}
</style>